import { FC, HtmlHTMLAttributes } from 'react';
import styled from '@emotion/styled';
const ModalHeaderLayout = styled.div`
  gap: 8px;
  box-sizing: border-box;
  padding: 20px 24px 8px 24px;
  min-height: 58px;
  z-index: 1;

  display: flex;
  border-bottom: 1px solid transparent;
  flex-direction: column;
  position: relative;

  /* ModalInner가 flex이기 때문에, flex로직에 의해 Header의 min-height가 의도대로 동작하지 않을 수 있음
  해당 문제를 해결하기 위해 flex-shrink: 0;을 추가해서, 축소를 방지함 */
  flex-shrink: 0;
`;
const ModalHeader: FC<HtmlHTMLAttributes<HTMLDivElement>> = ({
  children,
  ...props
}) => {
  return <ModalHeaderLayout {...props} data-sentry-element="ModalHeaderLayout" data-sentry-component="ModalHeader" data-sentry-source-file="ModalHeader.tsx">{children}</ModalHeaderLayout>;
};
export default ModalHeader;